import { Button, Box } from "@twilio-paste/core";
import styled from "styled-components";

const Botones = ({ curInteractives, sendMessageSurvey } : { curInteractives: any, sendMessageSurvey : any}) => {
    debugger;

    const StyledButtonsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
  `;

    const StyledButton = styled(Button)`
        font-size: 0.8rem;
        text-transform: none;
        margin-bottom: 5px;
        flex-direction: column-reverse !important;
        box-shadow: none;
        padding: 10px;
        &:hover {
          box-shadow: none;
        }
      `;
      
    // Render
    let i = 0;

    return (
        <StyledButtonsContainer>
            {curInteractives.options.map((o: any) => (
                <StyledButton
                    key={o.uuid}
                    onClick={() => {
                        i = 1;
                        if (i === 1) {
                            setTimeout(() => {
                                sendMessageSurvey(o.value);
                            }, 500);
                        }
                    }}
                    variant="primary"
                >
                    {o.content}
                </StyledButton>
            ))}
        </StyledButtonsContainer>
    );
};

export default Botones;
